import EventEmitter from '../../../plugins/EventEmitter';
import { debounce } from "../../../utils";

export default class Sizes extends EventEmitter {
    static _instance = null;

    static getInstance() {
        return Sizes._instance || new Sizes();
    }

    constructor() {
        super();

        if (Sizes._instance) {
            return Sizes._instance;
        }

        Sizes._instance = this;

        this.mobileResizeHeightThreshold = 100;
        this.currentBreakpoint = this.getBreakpoint();
        this.setSizes();
        this.initEvents();
    }

    setSizes() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.pixelRatio = Math.min(window.devicePixelRatio, 2);
    }

    getIsBreakpointMobile() {
        return window.matchMedia("(max-width: 767px)").matches
    }

    getIsBreakpointTablet() {
        return window.matchMedia("(max-width: 1024px)").matches
    }

    getBreakpoint() {
        if(this.getIsBreakpointTablet()) {
            return 'mobile'
        } else {
            return 'desktop'
        }
    }

    initEvents() {
        this.handleResize = debounce(this.onResize.bind(this), 100);
        window.addEventListener('resize', this.handleResize);
    }

    onResize() {
        if(this.currentBreakpoint !== this.getBreakpoint()) {
            this.reloadPage()
        }

        const heightDiff = Math.abs(window.innerHeight - this.height);

        const skipResize = window.innerWidth === this.width && heightDiff < this.mobileResizeHeightThreshold;

        this.setSizes();

        if(skipResize) {
            return
        }
        console.log('resize', this.width, this.height);
        this.trigger('resize');
    }

    reloadPage() {
        window.location.reload();
    }
}
